import { QuickSearchOutletsContactsResponse } from '../../../api/journodex/model/quick-search-outlets-contacts-response';
import { SearchCriteriaSourcesEnum } from '../../../api/mentions/enum/search-criteria-sources.enum';

export class JournodexSourceModel {
    id: string;
    entityType: SearchCriteriaSourcesEnum;
    entityName: string;
    entityLocation: string;
    displayString: string;

    private typeToStringMap = {
        [SearchCriteriaSourcesEnum.journalist]: '(CON)',
        [SearchCriteriaSourcesEnum.outlet]: '(OUT)',
        [SearchCriteriaSourcesEnum.urls]: '(URL)',
        [SearchCriteriaSourcesEnum.sourceGroups]: '(GRU)',
    };

    /**
     * Class constructor
     *
     * @param source
     */
    constructor(source?: QuickSearchOutletsContactsResponse) {
        if (source) {
            this.mapApiProvidedData(source);
        } else {
            this.id = null;
            this.entityType = null;
            this.entityName = '';
            this.entityLocation = '';
            this.displayString = '';
        }
    }

    /**
     * Map data from API response into front-end model
     *
     * @param source
     */
    private mapApiProvidedData(source: QuickSearchOutletsContactsResponse): void {
        this.id = '' + source.id;
        this.entityType = source.hasOwnProperty('entityType') ? source.entityType : null;
        this.entityName = source.hasOwnProperty('entityName') ? source.entityName : '';
        this.entityLocation = source.hasOwnProperty('location') ? source.location : '';

        this.displayString = this.entityName + this.typeToStringMap[this.entityType];
    }
}

